<script setup>
  import { storeToRefs } from "pinia";
  import { Input } from "@/components/ui/input";
  import { AiTextInput } from "@/components/episto-ui/ai";
  import { Label } from "@/components/ui/label";
  import { pricingTargetsFields } from "@utils/constants/pricingTargetsFields";
  import { usePricerProjectStore } from "@stores/pricer/pricerProject";
  import TargetFormCategory from "./FormCategory.vue";

  const projectStore = usePricerProjectStore();
  const { selectedTarget } = storeToRefs(projectStore);
</script>

<template>
  <div class="space-y-4">
    <div class="space-y-2">
      <Label>Name</Label>
      <Input
        v-model="selectedTarget.name"
        placeholder="Name" />
    </div>
    <div class="space-y-2">
      <Label>Description <span class="text-destructive">*</span></Label>
      <AiTextInput
        v-model="selectedTarget.description"
        type="input"
        placeholder="Description of the target" />
    </div>
    <div class="space-y-2">
      <Label>Comments</Label>
      <AiTextInput
        v-model="selectedTarget.comments"
        type="textarea"
        :rows="4"
        placeholder="Please add some comments here..." />
    </div>
    <div class="space-y-4 pt-4">
      <TargetFormCategory
        v-for="fieldCategory in pricingTargetsFields"
        :key="fieldCategory.name"
        :fields="fieldCategory.fields"
        :label="fieldCategory.label"
        :open="fieldCategory.open" />
    </div>
  </div>
</template>
